
import React from "react";
import _ from 'lodash';

// Used by CartSpecialOfferEntry to render the coupon code field,
// and TaxExemptWidget for the agents-only tax exempt widget.
export default function FieldWithApply({name, callbacks, id, shoppingCart = {},
  onChange, defaultValue, maxLength, placeholder, ...props}) {

  const handleChange = (event) => {
    const value = event.target.value;
    if (onChange) {
      onChange({name, value})
    } else {
      callbacks.updateCart({[name]: value});
    }
  }

  // the apply button does absolutely nothing.
  // it's just there to trick the user into leaving the text field,
  // creating an onBlur event
  const handleClick = (evt) => {
    console.log("apply button clicked");
  }

  // 2020-01 add maxLength because some people put their
  // entire life story in the tax exemption field
  if (typeof defaultValue === 'undefined') {
    defaultValue = shoppingCart[name];
  }

  return (<div className="field-with-apply">

    <input type="text" id={id} name={name}
      className="inline-block w-auto align-middle border border-gray-300 px-2 py-1 text-gray-600 rounded"
      maxLength={maxLength || 40}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onBlur={handleChange}/>

    {' '}
    <button type="button" onClick={handleClick}
      className="bg-gray-200 hover:bg-gray-200/75 px-4 py-1 ml-2 inline-block w-auto align-middle rounded">
      apply
    </button>
  </div>);

}
